// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-cooking-js": () => import("./../../../src/pages/cooking.js" /* webpackChunkName: "component---src-pages-cooking-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-playlists-js": () => import("./../../../src/pages/playlists.js" /* webpackChunkName: "component---src-pages-playlists-js" */)
}

